import { Box, Typography } from '@mui/material';

import { CONTENT, getEntityType } from './utils';
import { FinancialOverviewTiles } from './AccountingWidgets';
import { deriveBookkeepingSummary } from './deriveSummary';

import { useMember } from 'modules/common/queries/member';
import TaskCarousel from 'modules/Tasks/TaskCarousel';
import { TaskLocations } from 'modules/Tasks/types';

/**
 * Demo replacement for modules/Dashboard/Bookkeeping/Dashboard/Page. The prod tile grid
 * is a HurdlrIframe pointed at config.hurdlr.url.web — empty in the demo because the
 * Hurdlr config isn't wired and the iframe can't be served by MSW (different origin).
 * Tiles come from the shared AccountingWidgets file (also used by the Home page) so both
 * views stay in sync; tasks come from the prod accounting carousel, exactly like the real
 * page (BookkeepingLayout mounts the same `location` carousel).
 */

interface ContentShape {
    bookkeeping?: {
        transactions?: Parameters<typeof deriveBookkeepingSummary>[0];
    };
}

export default function DemoAccountingOverview() {
    const { data: member } = useMember();
    const content = CONTENT[getEntityType(member)] as ContentShape;

    // Derived from the transaction ledger at runtime (single source of truth).
    const { ytdIncome, ytdExpenses, mtdIncome, mtdExpenses, overview } = deriveBookkeepingSummary(
        content.bookkeeping?.transactions ?? []
    );

    return (
        <Box sx={{ width: '100%', maxWidth: 1440, mx: 'auto' }}>
            <Typography variant="h1" sx={{ mb: { xs: 4, md: 6 } }}>
                Accounting overview
            </Typography>
            <Box sx={{ mb: 6 }}>
                <TaskCarousel surface="location" location={TaskLocations.ACCOUNTING} />
            </Box>
            <FinancialOverviewTiles
                ytdIncome={ytdIncome}
                ytdExpenses={ytdExpenses}
                mtdIncome={mtdIncome}
                mtdExpenses={mtdExpenses}
                overview={overview}
            />
        </Box>
    );
}
